import React, { useState } from 'react';
import { ModalFormSection, ModalV2 } from 'components/common/modals';

import { subscriptionsServices } from '@services';
import { showError, formatDate } from '@utils';

import UploadSubscriptionDocumentForm from './UploadSubscriptionDocumentForm';

const AddDocumentModal = ({
  isOpen,
  onClose,
  subscriptionId,
  onGetSubscription,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('type', values.type);
      formData.append('documents', values.documents[0]);
      if (values.expire) {
        formData.append('expire', formatDate(values.expire, 'yyyy-MM-dd'));
      }
      await subscriptionsServices.addDocument(subscriptionId, formData);

      onGetSubscription();
      onClose();
    } catch (error) {
      showError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalV2
      id="add-new-subscription-document-modal"
      title="Upload New Document"
      isOpen={isOpen}
      size="sm"
      maxWidth="sm"
      onClose={onClose}
    >
      <ModalFormSection>
        <UploadSubscriptionDocumentForm
          onSubmit={handleSubmit}
          onCancel={onClose}
          isLoading={isLoading}
        />
      </ModalFormSection>
    </ModalV2>
  );
};
export default AddDocumentModal;
